import { render, staticRenderFns } from "./InnerPay.vue?vue&type=template&id=38e2d2cb&"
import script from "./InnerPay.vue?vue&type=script&lang=js&"
export * from "./InnerPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports